import axios, { AxiosError } from 'axios';
import attachAuthToken from './axiosConfig';

// API do painel "Movimentações retroativas" — competências cujo repasse mudou
// após o fechamento. ADR: docs/comissionamentos-adr-movimentacao-retroativa.md
export type QualificadoTipo = 'REGIONAL' | 'COOPERATIVA' | 'VOLUNTARIO';

export interface MovimentacaoRetroativa {
  qualificado_tipo: QualificadoTipo;
  qualificado_uuid: string;
  periodo: string; // MM-YYYY
  nome: string | null;
  codigo: string | null;
  valor_pago: number;
  valor_atual: number;
  delta: number;
  fechado_em: string;
}

export interface MovimentacoesResponse {
  totalItens: number;
  totalPages: number;
  page: number;
  limit: number;
  totalDelta: number;
  data: MovimentacaoRetroativa[];
}

export interface BoletoPosFechamento {
  entrada_id: string;
  regional_id: string | null;
  consultor_id: string | null;
  equipe_id: string | null;
  data_vencimento: string;
  data_pagamento: string;
  valor_pago: number;
  landed_em: string;
  pago_em_atraso: boolean;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});
attachAuthToken(api); // anexa o Bearer token (mesmo padrão dos demais api files)

const PATH = '/comissionamentos/movimentacoes-retroativas';

export async function listMovimentacoesRetroativas(params: {
  periodo?: string;
  page?: number;
  limit?: number;
}): Promise<MovimentacoesResponse> {
  try {
    const { data } = await api.get(PATH, { params });
    return data;
  } catch (e) {
    const err = e as AxiosError<any>;
    throw new Error(err.response?.data?.message || 'Erro ao listar movimentações retroativas');
  }
}

export async function listBoletosPosFechamento(periodo: string): Promise<{ data: BoletoPosFechamento[] }> {
  try {
    const { data } = await api.get(`${PATH}/boletos`, { params: { periodo } });
    return data;
  } catch (e) {
    const err = e as AxiosError<any>;
    throw new Error(err.response?.data?.message || 'Erro ao listar boletos pós-fechamento');
  }
}

export interface CompetenciaStatus {
  periodo: string; // MM-YYYY
  corte: string; // YYYY-MM-DD (último dia do mês)
  congela_em: string; // YYYY-MM-DD (5º dia útil do mês seguinte)
  congelado: boolean;
  fechado_em: string | null;
  boletos_em_aberto: number;
}

export async function getCompetenciasStatus(periodo?: string): Promise<{ data: CompetenciaStatus[] }> {
  try {
    const { data } = await api.get('/comissionamentos/competencias/status', { params: periodo ? { periodo } : {} });
    return data;
  } catch (e) {
    const err = e as AxiosError<any>;
    throw new Error(err.response?.data?.message || 'Erro ao obter status das competências');
  }
}
